import HistoriqueConstantes from '@/views/consultations/historique/view-historique/historique-constantes'
import HistoriqueMotifConsultation from '@/views/consultations/historique/view-historique/historique-motif-consultation'
import HistoriqueAnamneses from '@/views/consultations/historique/view-historique/historique-anamneses'
import HistoriqueExamenClinique from '@/views/consultations/historique/view-historique/historique-examen-clinique'
import HistoriqueHypotheseDiagnostique from '@/views/consultations/historique/view-historique/historique-hypothese-diagnostique'
import HistoriqueDiagnostic from '@/views/consultations/historique/view-historique/historique-diagnostic'
import HistoriqueAnalyseBiologique from '@/views/consultations/historique/view-historique/historique-analyse-biologique'
import HistoriqueImagerieMedicale from '@/views/consultations/historique/view-historique/historique-imagerie-medicale'
import HistoriqueOrdonnance from '@/views/consultations/historique/view-historique/historique-ordonnance'
import HistoriqueInfoComplementaire from '@/views/consultations/historique/view-historique/historique-info-complementaire'
import HistoriqueProtocoleSoins from '@/views/consultations/historique/view-historique/historique-protocole-soins'
import HistoriqueTraitementProtocole from '@/views/consultations/historique/view-historique/historique-traitement'
import HistoriqueSectionContents from '@/views/consultations/historique/view-historique/historique-section-contents'
import HistoriqueOrdonnaceLunettes from '@/views/consultations/historique/view-historique/historique-ordonnance-lunettes'
import HistoriqueAcuiteVisuelle from '@/views/consultations/historique/view-historique/historique-acuite-visuelle'
import HistoriqueGrossesse from '@/views/consultations/historique/view-historique/historique-grossesse'
import HistoriqueExamenFE from '@/views/consultations/historique/view-historique/historique-examen-fe'

import FiltreDate from '@/views/consultations/historique/view-historique/historique-date-filter'
import ResultatPatientModal from '@/views/analyse/registre_analyse/resultat-patient-modal'
import VoirResultat from '@/views/analyse/visualiser-resultat';
import ExamenPreviewResult from '@/views/consultations/en-cours/examen-para/examen-preview-result'
import $ from 'jquery'

export default {
    name: 'view-historique',
    components: {
        HistoriqueConstantes, HistoriqueMotifConsultation, HistoriqueAnamneses,
        HistoriqueExamenClinique, HistoriqueHypotheseDiagnostique,
        HistoriqueDiagnostic, HistoriqueAnalyseBiologique, HistoriqueImagerieMedicale,
        HistoriqueOrdonnance, HistoriqueInfoComplementaire, HistoriqueProtocoleSoins,
        HistoriqueTraitementProtocole, FiltreDate, ResultatPatientModal, VoirResultat,
        ExamenPreviewResult, HistoriqueSectionContents, HistoriqueOrdonnaceLunettes,
        HistoriqueAcuiteVisuelle, HistoriqueGrossesse, HistoriqueExamenFE
    },
    props: {
        selected_consultation: Object,
        event_trigger: Number,
        patient: Object
    },
    data() {
        return {
            group_section_loading: true,
            historique_loading: true,
            historique_empty: false,

            section_is_loading: true,
            section_is_empty: false,
            current_evolution_id: 0,

            filter_by_section: '',
            filter_by_date: {},
            filter_by_order: {
                slug: 'ASC', libelle: 'Ascendant'
            },

            ordering_filters: [
                {
                    slug: 'ASC', libelle: 'Ascendant'
                },
                {
                    slug: 'DESC', libelle: 'Descendant'
                }
            ],

            date_filters: [
                { slug: 'date', libelle: 'Date' },
                { slug: 'entre_deux_date', libelle: 'Entre deux dates' }
            ],

            filter_options: {
                section: '',
                order: '',
                from_date: '',
                to_date: '',
                one_date: ''
            },
            active_sections: [],
            filename: '',
            results: null,
            view_result_loading: false,
            historique_evolution_id: 0,

            evolution_id: 0,
            demande_analyse: {},
            demande_examen: {},
            info_resultat: {},
            toggler: 0,
            result_toggler: 0,
            can_print: false,
        }
    },

    watch: {
        event_trigger() {
            this.refreshListConsultationGroupSection()
        },

        filter_by_date() {
            if (this.filter_by_date.slug) {
                $('.date-filter').modal('show')
            }
        },

        filter_by_section() {
            this.filter_options.section = this.filter_by_section.slug
            this.refreshHistoriqueConsultation()
        },

        filter_by_order() {
            this.filter_options.order = this.filter_by_order.slug
            this.refreshHistoriqueConsultation()
        }
    },

    computed: {
        consultation_group_sections() {
            return this.$store.getters["consultation_group_sections"];
        },

        consultation_historiques() {
            return this.$store.getters["consultation_historiques"];
        },

        active_group_sections() {
            return this.$store.getters["active_group_sections"];
        },

        can_print_historique() {
            return this.$store.getters['can_print_historique']
        }, 

        activeRole() {
            return this.$store.getters['activeRole'];
        },
    },

    mounted() {
        this.refreshListConsultationGroupSection()

        const d = new Date()
        const tmpstamp = d.getHours()+''+d.getMinutes()+''+d.getFullYear()
        this.filename = 'Historique de consultation_'+tmpstamp

        this.$store.commit("SET_CAN_PRINT_HISTORIQUE", false)
        this.$store.commit("SET_HISTORIQUE_TO_PRINT", {})
    },

    methods: {
        refreshListConsultationGroupSection() {
            this.group_section_loading = true

            this.$store.dispatch('getListeConsultationGroupSection', this.selected_consultation.consultation_id).then(() => {
                this.group_section_loading = false
            })
            // this.refreshActiveSection()
            // this.getCurrentEvolution()
        },

        getHistoriqueConsultation(evolution_id) {
            this.current_evolution_id = evolution_id
            this.historique_loading = true
            const data = {
                consultation_id: this.selected_consultation.consultation_id,
                evolution_id: evolution_id,
                filter_options: this.filter_options
            }

            this.$store.dispatch('getListeHistoriqueConsultation', data).then(() => {
                if (this.consultation_historiques.length == 0) {
                    this.historique_empty = true
                } else {
                    this.historique_empty = false
                }

                this.historique_loading = false
            })

            const curr_evolution_data = {
                consultation_id: this.selected_consultation.consultation_id,
                groupe_id: evolution_id
            }
            this.refreshListOfActiveGroupSection(curr_evolution_data)
        },

        backToListConsultation() {
            this.$emit('emitHistoriqueToggler')
        },

        refreshListOfActiveGroupSection(data) {
            this.section_is_loading = true

            this.$store.dispatch('getListeOfActiveGroupSections', data).then(() => {
                this.active_sections = this.active_group_sections
                if (this.active_group_sections.length == 0) {
                    this.section_is_empty = true
                } else {
                    const t = {
                        id: 0,
                        is_default: 0,
                        libelle: "Traitement",
                        ordre: 99,
                        slug: "traitement_prot_soins",
                        user_id: null
                    }
                    
                    
                    this.active_sections = [...this.active_sections, t]
                    this.section_is_empty = false
                }
                this.section_is_loading = false
            })
        },

        filterByDate(date) {
            if (date.historique_date != '') {
                this.filter_options.one_date = date.historique_date
            } else {
                this.filter_options.from_date = date.from_date
                this.filter_options.to_date = date.to_date
            }
            this.refreshHistoriqueConsultation()
        },

        refreshHistoriqueConsultation() {
            this.getHistoriqueConsultation(this.current_evolution_id)
        },

        resetFilter() {
            this.filter_by_section = ''
            this.filter_by_date = {}
            this.filter_by_order = {
                slug: 'ASC', libelle: 'Ascendant'
            }

            this.filter_options = {
                section: '',
                order: '',
                from_date: '',
                to_date: '',
                one_date: ''
            }
        },

        openResultsModal(param_result) {
            this.view_result_loading = true
            $('#view-analysis-modal').modal('show');

            this.historique_evolution_id = param_result.historique.bulletin_id
            const param = {
                analyseId: param_result.demande_analyse.analyse_id,
                bulletinId: param_result.historique.bulletin_id,
            }
            this.$store.dispatch("getResultsByAnalyseIdBulletinId", param).then((response) => {
                this.results = response.data;
                this.view_result_loading = false
            })
        },

        printResultatAnalyse(results) {
            this.$store.commit("SET_RESULAT_PATIENT_TO_PRINT", results)
            this.$store.commit("SET_CAN_PRINT_RESULT", true)
        },

        setResultUploaded(param) {
            this.toggler = (this.toggler == 0)?1:0
            this.demande_analyse = param.demande_analyse
            this.evolution_id = param.evolution_id
            setTimeout(() => {
                $('#modalResultat'+param.evolution_id).modal('show');
            }, 500);
        },

        setResultImagerie(param) {
            this.result_toggler = (this.result_toggler == 0)?1:0
            this.demande_examen = param.result_preview
            this.info_resultat = param.info_resultat
            this.evolution_id = param.evolution_id
            setTimeout(() => {
                $('#view-result-examen'+param.evolution_id+param.info_resultat.demande_id).modal('show');
            }, 500);
        },

        printHistorique() {
            this.can_print = true
            setTimeout(() => {
                window.print()

                this.can_print = false
            }, 500);
        },


        printHisto(consultation_historiques) {
            this.$store.commit("SET_CAN_PRINT_HISTORIQUE", true)
            this.$store.commit("SET_HISTORIQUE_TO_PRINT", consultation_historiques)
        },
    }
}


